import { Routes } from '@angular/router';
import { LayoutComponent } from './pages/layout/layout.component';
import { authGuard, Constants } from './_utility';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { HomePrenotazioniComponent } from './pages/home-prenotazioni/home-prenotazioni.component';
import { HomeRistorantiComponent } from './pages/home-ristoranti/home-ristoranti.component';
import { NewRestaurantComponent } from './pages/new-restaurant/new-restaurant.component';
import { EditRestaurantComponent } from './pages/edit-restaurant/edit-restaurant.component';
import { SlotManagementComponent } from './pages/slot-management/slot-management.component';
import { EditSlotComponent } from './pages/edit-slot/edit-slot.component';
import { AdministrationComponent } from './pages/administration/administration.component';
import { ExtractionComponent } from './pages/extraction/extraction.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { NotAllowedComponent } from './pages/not-allowed/not-allowed.component';
import { ThirdPartReservationComponent } from './pages/third-part-reservation/third-part-reservation.component';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: Constants.Routing.LOGIN.path, component: LoginComponent },
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: Constants.Routing.HOME.path, component: HomeComponent, canActivate: [authGuard] },
      { path: Constants.Routing.HOME_PRENOTAZIONI.path, component: HomePrenotazioniComponent, canActivate: [authGuard] },
      { path: Constants.Routing.HOME_RISTORANTI.path, component: HomeRistorantiComponent, canActivate: [authGuard] },
      { path: Constants.Routing.NUOVO_RISTORANTE.path, component: NewRestaurantComponent, canActivate: [authGuard] },
      { path: Constants.Routing.MODIFICA_RISTORANTE.path, component: EditRestaurantComponent, canActivate: [authGuard] },
      { path: Constants.Routing.GESTIONE_SLOT.path, component: SlotManagementComponent, canActivate: [authGuard] },
      { path: Constants.Routing.MODIFICA_SLOT.path, component: EditSlotComponent, canActivate: [authGuard] },
      { path: Constants.Routing.ADMINISTRATION.path, component: ThirdPartReservationComponent, canActivate: [authGuard] },
      { path: Constants.Routing.ADMINISTRATION_TABLE.path, component: AdministrationComponent, canActivate: [authGuard] },
      { path: Constants.Routing.EXTRACTION.path, component: ExtractionComponent, canActivate: [authGuard] },
      { path: Constants.Routing.NOT_FOUND.path, component: NotFoundComponent, canActivate: [] },
      { path: Constants.Routing.NOT_ALLOWED.path, component: NotAllowedComponent, canActivate: [] },
    ],
  },
  { path: '**', redirectTo: '/not-found' },
];
